import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import "./Contact.css";

const Contact = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const cardRef = useRef(null);
  const infoRef = useRef(null);

  const [result, setResult] = useState("");

  useEffect(() => {
    // ===== Title Animation =====
    gsap.fromTo(
      titleRef.current,
      { y: -40, opacity: 0 },
      { y: 0, opacity: 1, duration: 1.2, ease: "power3.out" }
    );

    // ===== Contact Form Animation =====
    gsap.fromTo(
      cardRef.current,
      { y: 80, opacity: 0 },
      { y: 0, opacity: 1, duration: 1.4, delay: 0.2, ease: "power3.out" }
    );

    // ===== Info Card Animation =====
    gsap.fromTo(
      infoRef.current,
      { y: 80, opacity: 0 },
      { y: 0, opacity: 1, duration: 1.4, delay: 0.4, ease: "power3.out" }
    );

    // ===== Floating Loop =====
    gsap.to([cardRef.current, infoRef.current], {
      y: -10,
      duration: 3,
      ease: "sine.inOut",
      repeat: -1,
      yoyo: true,
      delay: 1.5,
    });
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");

    const formData = new FormData(event.target);
    formData.append("access_key", "8423ea79-facc-49eb-9698-285c3bc94bdd");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully ✅");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <section id="contact" className="contact-section" ref={sectionRef}>
      {/* Title */}
      <h1 className="brand-title" ref={titleRef}>
        Contact Acence
      </h1>

      <div className="contact-wrapper">
        {/* ===== Contact Form Card ===== */}
        <div className="contact-card" ref={cardRef}>
          <h3>Making Your Brand Fly</h3>

          <form onSubmit={onSubmit} className="contact-form">
            <label>Your Name*</label>
            <input type="text" name="name" placeholder="Enter your name" required />

            <label>Phone Number*</label>
            <input type="tel" name="phone" placeholder="Enter your phone number" required />

            <label>Write your message here</label>
            <textarea name="message" rows="5" placeholder="Enter your message" required />

            <button type="submit" className="btn-3d">
              Submit now
            </button>
          </form>

          <span>{result}</span>
        </div>

        {/* ===== Info Card ===== */}
        <div className="contact-info-card" ref={infoRef}>
          <div className="info-block">
            <a
              href="https://wa.me/917678136253"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-link"
            >
              +91 7678136253
              
            </a>

            <p>
              <a
                href="mailto:acenceofficial@gmail.com"
                className="whatsapp-link"
              >
                acenceofficial@gmail.com
              </a>
            </p>
          </div>

          <p className="footer-text">
            © 2026 Acence <br />
            Powered by <span>Ignite</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
